import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";

const ConfirmDialog = ({ open, title, onDeny, onConfirm }) => {
  const { t: getLabel } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const handleKeyDown = e => {
      if (e.key === "Escape") {
        onDeny();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onDeny]);

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{getLabel(LangConstant.L_CONFIRM_BUTTON)}</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onDeny}></button>
            </div>
            <div className="modal-body">
              <p className="mb-0">{title}</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-link link-secondary me-auto" onClick={onDeny}>
                {getLabel(LangConstant.L_CANCEL)}
              </button>
              <button className="btn btn-primary" onClick={onConfirm}>
                {getLabel(LangConstant.L_CONFIRM_BUTTON)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmDialog;
